export const CLINICALDASHBOARD_ACTIONS = {
  CHANGE_SELECTED_DASHBOARD: 'CHANGE_SELECTED_DASHBOARD',
  CLEAR_CLINICAL_DASHBOARD: 'CLEAR_CLINICAL_DASHBOARD',
  UPDATE_TREND_GROUPS: 'UPDATE_TREND_GROUPS',
  UPDATE_TREND_SELECTED_FILTER: 'UPDATE_TREND_SELECTED_FILTER',
  CLEAR_CLINICAL_TREND_GROUPS: 'CLEAR_CLINICAL_TREND_GROUPS'
};
